import { render, staticRenderFns } from "./courseInfo.vue?vue&type=template&id=3e87ef86&scoped=true&"
import script from "./courseInfo.vue?vue&type=script&lang=js&"
export * from "./courseInfo.vue?vue&type=script&lang=js&"
import style0 from "./courseInfo.vue?vue&type=style&index=0&id=3e87ef86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e87ef86",
  null
  
)

export default component.exports